<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jenny Walker lives in Northallerton, the County Town of North Yorkshire. She has spent most of her life working in offices where, amongst other things, she achieved ISO:9001 and IIP, along with writing H&amp;S manuals, company handbooks and HR documentation.</p>
<p>In complete contrast, Jenny also spent several years as a poultry breeder. Jenny is now a full-time author.</p>
<p><em>www.jennywalkerauthor.com</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7cea4c34